const pad = (value: number): string => value.toString().padStart(2, "0")

/** Default prefix used for Leumit landing / retake session ids. */
export const DEFAULT_SESSION_ID_PREFIX = "leumitTestDefault"

/**
 * Builds a sessionId as `<prefix>` + `HHmm_ddMMyyyy`.
 */
export const buildSessionId = (prefix: string): string => {
  const now = new Date()
  const timePart = `${pad(now.getHours())}${pad(now.getMinutes())}`
  const datePart = `${pad(now.getDate())}${pad(now.getMonth() + 1)}${now.getFullYear()}`
  return `${prefix}${timePart}_${datePart}`
}
